import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHero from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { useI18n } from "../i18n";

export default function About() {
  const { t } = useI18n();
  return (
    <>
      <PageHero label={t.about.label} title={t.about.heading} image="https://images.unsplash.com/photo-1765285334055-e2ecffe7ccc0?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000" alt="Vienna architecture" />
      <section className="bg-[#F7F5F0] py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-12">
          <div className="md:col-span-3"><Reveal><p className="label text-[#C5A880]">SBG</p></Reveal></div>
          <div className="md:col-span-8 space-y-10">
            <Reveal><p className="font-body text-[#2A2A2A]/80 text-xl md:text-2xl leading-relaxed">{t.about.body}</p></Reveal>
            <Reveal delay={0.1}><p className="font-serif-display italic text-[#062029] text-2xl md:text-4xl leading-snug">{t.about.p2}</p></Reveal>
          </div>
        </div>
      </section>
      <section className="bg-[#062029] py-0 grain overflow-hidden">
        <div className="relative h-[60vh]">
          <img src="https://images.unsplash.com/photo-1655919640606-28088c64edb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000" alt="International mobility" className="w-full h-full object-cover opacity-40" />
          <div className="absolute inset-0 flex items-center justify-center px-6 text-center">
            <div>
              <p className="font-serif-display text-[#F7F5F0] text-3xl md:text-6xl leading-tight max-w-4xl">{t.footer.tagline}</p>
              <Reveal delay={0.2}>
                <Link to="/contact" data-testid="about-cta" className="inline-flex items-center gap-3 mt-10 border border-[#C5A880]/60 text-[#F7F5F0] px-8 py-4 text-[12px] tracking-widest uppercase hover:bg-[#C5A880] hover:text-[#062029] transition-colors duration-500">
                  {t.nav.cta} <ArrowUpRight size={16} />
                </Link>
              </Reveal>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
